import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tgContainer" }
const _hoisted_2 = { class: "tgMenuArea" }
const _hoisted_3 = { class: "tgLeftContainer" }
const _hoisted_4 = { class: "tgSearchArea" }
const _hoisted_5 = { class: "tgConvListArea" }
const _hoisted_6 = { class: "tgMsgArea" }

import TgSearch from '@/components/telegram/TgSearch.vue';
import TgConvWindow from "@/components/telegram/TgConvWindow.vue";
import TgContactWindow from "@/components/telegram/TgContactWindow.vue";
import tgSearchWindowVue from '@/components/telegram/tgSearchWindow.vue';
import TgMsgWindow from "@/components/telegram/TgMsgWindow.vue";
import TgMenu from '@/components/telegram/TgMenu.vue';
import TgContactMsgWindow from '@/components/telegram/TgContactMsgWindow.vue';
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import { onMounted, onUnmounted } from "vue";
import { computed } from "vue";
import { TgActions, TgGetters, TgMutations } from "@/store/modules/telegram";



import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "TgContainer"
})



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const store = useStore();
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const selectMenu = computed(() => {
    return store.getters[`telegram/${TgGetters.getSelectMenu}`];
});


onMounted(() => {
    let projid = projectId.value
    let uid = targetId.value
    // store.dispatch(`telegram/${TgActions.asyncGetMeId}`, { projid, uid });
})

onUnmounted(() => {
    store.commit(`telegram/${TgMutations.resetAll}`);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TgMenu)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TgSearch)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(selectMenu) === '1')
          ? (_openBlock(), _createBlock(TgConvWindow, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(selectMenu) === '2')
          ? (_openBlock(), _createBlock(TgContactWindow, { key: 1 }))
          : _createCommentVNode("", true),
        (_unref(selectMenu) === '4')
          ? (_openBlock(), _createBlock(tgSearchWindowVue, { key: 2 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_unref(selectMenu) == '1' || _unref(selectMenu) == '4')
        ? (_openBlock(), _createBlock(TgMsgWindow, {
            key: 0,
            isGetMsgByTarget: 0
          }))
        : _createCommentVNode("", true),
      (_unref(selectMenu) === '2')
        ? (_openBlock(), _createBlock(TgContactMsgWindow, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})